import React from 'react';

import { Location } from 'history';
import { match } from 'react-router';
import { NavLink } from 'react-router-dom';

import { BREAK_POINT } from 'constants/responsive';

import './BreadcrumbTrail.sass';

interface IProps {
    pathNodes: {
        label: string;
        route: string;
        isActiveOverride?: (match: match<{}>, location: Location) => boolean;
    }[];
}

const BreadcrumbTrail: React.StatelessComponent<IProps> = (props: IProps) => {
    if (props.pathNodes.length < 1) return(null);
    return (
        <div className={`BreadcrumbTrail${window.innerWidth < BREAK_POINT ? '-mobile' : ''}`}>
            <NavLink key={props.pathNodes[0].label} exact to={props.pathNodes[0].route}>{props.pathNodes[0].label}</NavLink>
            {
                props.pathNodes.slice(1).map((pathNode, index) => {
                    return <span key={pathNode.label} > / <NavLink isActive={pathNode.isActiveOverride}  exact to={pathNode.route}>{pathNode.label}</NavLink></span>;
                })
            }
        </div>
    );
};

export default BreadcrumbTrail;



// WEBPACK FOOTER //
// ./src/components/global/application/BreadcrumbTrail.tsx